import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingPageComponent } from './loading-page.component';
import { MaterialModule } from 'src/app/core/shared/util/material/material.module';

@NgModule({
  declarations: [LoadingPageComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [LoadingPageComponent]
})
export class LoadingPageModule { }
